module.exports = __webpack_public_path__ + "static/img/蒙版组 13.5096e2c.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/declaration/images/蒙版组 13.png
// module id = WlLV
// module chunks = 0